export default __webpack_public_path__ + "static/media/play_btn.a91d9fd4.png";